import React, { useEffect, useState, useRef } from "react";
import "../css/paysuccess.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
// import { successPay } from "../apis/SuccessAPI";
import { PixelWithEvent } from "./common/PixelWithEvent ";
import * as FacebookAPI from "../apis/FacebookAPI";
import { sendMessage } from "../apis/SendMessageAPI";
import { BASE_URL } from "../constans/ApiEndpointConstants";
import { getOrder } from "../apis/GetOrder";
import Cookie from "react-cookies";
import Cookies from "js-cookie";
import LocalStorageUtil from "../utils/localStorageUtil";
import { useTranslation } from "react-i18next";
import {
  whatsapp,
  telegram,
  tiktok,
  instagram,
} from "../constans/ColorConstants";

const PaySuccess = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const ad = LocalStorageUtil.getAd() || "PurityBase";
  // eslint-disable-next-line no-unused-vars
  const [orderDetails, setOrderDetails] = useState(null);
  const [shareCount, setShareCount] = useState(0);
  const [progress, setProgress] = useState(0);
  const [msgHidden, setMsgHidden] = useState(true);
  const [returnMsg, setReturnMsg] = useState("");
  // 使用 useRef 防止在 StrictMode 下重复调用 successcallback
  const hasProcessedPurchase = useRef(false);
  const orderNo = searchParams.get("clientNo");
  const redirectStatus = searchParams.get("redirect_status");
  const isRedirectSucceeded =
    redirectStatus === null ? true : redirectStatus === "succeeded";
  const rawEmailParam = searchParams.get("email") || "";
  let email = rawEmailParam;
  let phone = searchParams.get("phone") || "";
  if (typeof rawEmailParam === "string" && rawEmailParam.includes("?phone=")) {
    const idx = rawEmailParam.indexOf("?phone=");
    const emailPart = rawEmailParam.slice(0, idx);
    const phonePart = rawEmailParam.slice(idx + 7).split(/[&#]/)[0];
    email = emailPart;
    if (!phone && phonePart) {
      phone = phonePart;
    }
  }

  //event_id，要去重，一天之内用一个，存cookie
  const getEventId = (eventType) => {
    // 根据事件类型使用不同的cookie名
    const cookieName = `fb_event_id_${eventType}`;

    let storedEventId = Cookies.get(cookieName);
    if (storedEventId) {
      return storedEventId;
    } else {
      // 使用 10 位随机数字作为 event_id
      const newEventId = Math.round(Math.random() * 10000000000).toString();
      Cookies.set(cookieName, newEventId, { expires: 1 }); // 存储1天
      return newEventId;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const shareOptions = [
    {
      id: "whatsapp",
      name: "WhatsApp",
      icon: (
        <svg
          t="1763977259813"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="44607"
          width="200"
          height="200"
        >
          <path
            d="M512 1024C229.10781 1024-0.121905 794.819048 0 511.951238 0 229.180952 229.10781 0 512 0c282.770286 0 512 229.180952 512 511.951238C1024 794.794667 794.770286 1024 512 1024zM202.825143 827.367619l160.134095-41.203809a311.369143 311.369143 0 0 0 152.429714 39.740952c171.885714 0 311.734857-139.849143 311.734858-311.734857S687.299048 202.459429 515.413333 202.459429c-171.910095 0-311.759238 139.824762-311.759238 311.710476 0 55.832381 14.799238 110.177524 42.910476 157.939809L202.849524 827.367619z m168.326095-97.913905l-92.525714 23.79581 25.185524-89.404953-6.436572-9.99619a257.901714 257.901714 0 0 1-40.862476-139.678476c0-142.726095 116.126476-258.82819 258.876952-258.828191 142.726095 0 258.852571 116.102095 258.852572 258.828191S658.115048 773.022476 515.413333 773.022476c-47.664762 0-94.232381-13.04381-134.704762-37.741714l-9.508571-5.851429z m56.661333-360.350476l-20.23619-1.121524a24.454095 24.454095 0 0 0-17.383619 5.948953c-9.825524 8.533333-25.502476 24.990476-30.305524 46.445714-7.192381 31.98781 3.900952 71.143619 32.646095 110.323809 28.720762 39.15581 82.261333 101.839238 176.932572 128.609524 30.47619 8.606476 54.491429 2.80381 73.020952-9.020952a65.29219 65.29219 0 0 0 28.40381-41.472l3.242666-15.09181a10.48381 10.48381 0 0 0-5.851428-11.702857l-68.388572-31.50019a10.48381 10.48381 0 0 0-12.678095 3.096381l-26.843428 34.791619a7.68 7.68 0 0 1-8.630858 2.584381c-18.383238-6.460952-79.969524-32.256-113.737142-97.328762a7.753143 7.753143 0 0 1 0.975238-8.630857l25.648762-29.671619a10.48381 10.48381 0 0 0 1.706666-10.971429l-29.476571-68.949333a10.48381 10.48381 0 0 0-9.045334-6.339048z"
            fill="#15D135"
            p-id="44608"
          ></path>
        </svg>
      ),
      color: "#25D366",
      url: whatsapp,
    },
    {
      id: "telegram",
      name: "Telegram",
      icon: (
        <img
          src={process.env.PUBLIC_URL + "/share/telegram.png"}
          alt="Telegram"
          width={60}
          height={60}
          loading="lazy"
        />
      ),
      color: "#0088cc",
      url: telegram,
    },
    {
      id: "tiktok",
      name: "TikTok",
      icon: (
        <svg
          t="1773223372060"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="7961"
          width="200"
          height="200"
        >
          <path
            d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1"
            p-id="7962"
            fill="#1a1a1a"
          ></path>
        </svg>
      ),
      color: "#000000",
      url: tiktok,
    },
    {
      id: "instagram",
      name: "Instagram",
      icon: (
        <svg
          t="1773223402388"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="9008"
          width="200"
          height="200"
        >
          <path
            d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9z m0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zM725.5 250.7c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9c-0.1-26.6-21.4-47.9-47.9-47.9z"
            p-id="9009"
            fill="#1a1a1a"
          ></path>
          <path
            d="M911.8 512c0-55.2 0.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-0.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-0.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9 0.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165z m-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
            p-id="9010"
            fill="#1a1a1a"
          ></path>
        </svg>
      ),
      color: "#E1306C",
      url: instagram,
    },
  ];

  const [loading, setLoading] = useState(true);

  // 随机生成六位字符（包含数字和字母）
  const generateRandomCode = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 6; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    return result;
  };

  // 获取或生成 userid
  let userid = localStorage.getItem("userid");
  if (!userid) {
    userid = generateRandomCode();
    localStorage.setItem("userid", userid);
  }

  //从接口获取orderDetails（依赖 successEmailTemplateId，确保模板已就绪）
  const getOrderRes = async (retryCount = 0) => {
    try {
      const res = await getOrder(orderNo);
      
      const states = res.data?.data?.states;
      
      // 如果获取到了 states 为 1，则代表支付成功
      if (states === 1) {
        const order = res.data.data.data;
        const parsedOrder = JSON.parse(order);

        setOrderDetails(parsedOrder);
        successcallback(parsedOrder);
        setLoading(false);
        return;
      }

      // 如果 states 还是 0，或者还未变成 1，则进行轮询重试
      // 如果后端还没处理完回调，重试最多5次，每次间隔2秒
      if (retryCount < 5) {
        setTimeout(() => {
          getOrderRes(retryCount + 1);
        }, 2000);
        return;
      } else {
        // 重试 5 次后依然为 0，才判定为失败跳转
        navigate("/payfial");
        return;
      }
    } catch (error) {
      console.error("获取订单信息失败:", error);
      navigate("/payfial");
    }
  };

  // 处理支付成功回调（拉取订单信息并上报像素）
  useEffect(() => {
    if (!orderNo || !isRedirectSucceeded) {
      navigate("/payfial");
      return;
    }

    // 使用 localStorage 跟踪是否已为当前订单发送过消息
    const messageSentKey = `successPayMessageSent_${orderNo}`;
    const hasSentMessage = localStorage.getItem(messageSentKey);

    if (!hasSentMessage) {
      sendMessage(BASE_URL + `[ Success Pay]:ad=${ad}:userid=${userid}  `);
      // 标记已发送，避免刷新时重复发送
      localStorage.setItem(messageSentKey, "true");
    }

    getOrderRes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderNo, isRedirectSucceeded]);

  // 初始化分享进度
  useEffect(() => {
    const savedCount = localStorage.getItem("shareCount");
    const savedProgress = localStorage.getItem("progress");

    if (savedCount) {
      setShareCount(parseInt(savedCount, 10));
    }

    if (savedProgress) {
      const parsedProgress = parseInt(savedProgress, 10);
      setProgress(parsedProgress);

      // 如果 progress 已经是 100，则自动显示第三条 returnMsg
      if (parsedProgress === 100) {
        setReturnMsg(t("success.share.return.msg7"));
      }
    }
  }, [t]);

  // facebookApi
  const successcallback = (orderDetail) => {
    // 防止在 StrictMode 下重复调用
    if (hasProcessedPurchase.current) {
      return;
    }

    let flag = Cookie.load("purchased");

    console.log(orderDetail);

    // 如果 flag 不存在，或者订单号不一样，则继续执行
    if (!flag) {
      // 标记为已处理，防止重复调用
      hasProcessedPurchase.current = true;
      const event_id = getEventId("Purchase");

      const eventData = {
        value: orderDetail.amount,
        content_ids: ["cart"],
        content_name: "Success Buy",
        content_type: "product",
        contents: [
          {
            id: "cart",
            title: "Cart",
            quantity: 1,
          },
        ],
        currency: "USD",
        num_items: 1,
      };

      let userdata = {
        em: orderDetail.email,
        ph: orderDetail.phone,
        fn: orderDetail.firstName,
        ln: orderDetail.lastName,
        ct: orderDetail.city,
        st: orderDetail.state,
        zp: orderDetail.zipCode,
        country: orderDetail.country,
      };

      PixelWithEvent("Purchase", event_id);

      FacebookAPI.Facebook(
        orderDetail?.fbqToken,
        orderDetail?.pixel,
        event_id,
        "Purchase",
        eventData,
        userdata
      )
        .then((res) => {
          sendMessage(BASE_URL + `[Purchase]:ad=${ad}:userid=${userid}  `);

          sendMessage(`purchase eventsAll---${JSON.stringify(res)}`);
          localStorage.removeItem("orderDetail");
          const now = new Date();
          now.setMonth(now.getMonth() + 1); // 设置为当前时间 + 1 个月

          // 保存 purchased flag 和订单号到 cookie
          Cookie.save("purchased", "purchased", {
            expires: now,
            path: "/",
          });
        })
        .catch((err) => {
          console.error("Failed to send event", err);
          // 如果失败，重置标记以便重试
          hasProcessedPurchase.current = false;
        });
    }
  };

  const backToProduct = () => {
    navigate("/");
  };

  const handleShareOptionClick = (option) => {
    if (!option.url) {
      return;
    }

    handleShareClick(option.name);

    if (option.sameTab) {
      window.location.href = option.url;
      return;
    }

    window.open(option.url, option.target || "_blank", "noopener,noreferrer");
  };

  // 处理分享操作
  const handleShareClick = (platformName = "") => {
    // 发送分享消息
    sendMessage(
      BASE_URL +
        `[Success Share]:ad=${ad}:userid=${userid}:platform=${platformName}  `
    );

    let newShareCount = shareCount + 1;
    let newProgress = progress;

    if (newShareCount !== 3 && newShareCount !== 5) {
      newProgress = Math.min(newProgress + 20, 100);
    }

    setShareCount(newShareCount);
    setProgress(newProgress);

    //将分享次数和进度条进度存在本地缓存
    localStorage.setItem("shareCount", newShareCount);

    // 延迟更新进度条
    setTimeout(() => {
      setProgress(newProgress);
      localStorage.setItem("progress", newProgress);
    }, 800); // 800ms 延迟更新进度条

    setMsgHidden(false);

    // 延迟显示不同的消息
    setTimeout(() => {
      if (newShareCount === 3) setReturnMsg(t("success.share.return.msg3"));
      else if (newShareCount >= 7) setReturnMsg(t("success.share.return.msg7"));
      else setReturnMsg("");
    }, 800); // 800ms 延迟显示消息
  };

  if (loading) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
        {/* Loading spinner or text */}
        <p>{t("account.common.loading") || "Loading..."}</p>
      </div>
    );
  }

  return (
    <>
      {/* top */}
      <div className="product_box_top success_product_box_top">
        <div
          className="product_box_top_left"
          onClick={backToProduct}
          style={{ cursor: "pointer" }}
        >
          <svg
            t={1763633148216}
            className="icon"
            viewBox="0 0 1024 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id={2746}
            width={200}
            height={200}
          >
            <path
              d="M297.813333 491.648l1.365334-1.749333 379.093333-376.149334a38.784 38.784 0 0 1 5.077333-4.096 34.346667 34.346667 0 0 1 14.293334-4.992c2.218667-0.170667 2.176-0.170667 4.394666-0.170666a33.493333 33.493333 0 0 1 14.549334 4.181333c12.330667 6.997333 18.688 21.76 15.274666 35.498667-1.237333 5.077333-7.04 13.44-7.04 13.44l-355.498666 352.853333 354.090666 354.389333s6.272 7.978667 7.893334 12.928a32.213333 32.213333 0 0 1-33.749334 41.557334c-6.656-0.682667-17.749333-7.68-17.749333-7.68l-379.221333-377.984-1.28-1.450667a30.378667 30.378667 0 0 1-7.893334-17.749333 31.018667 31.018667 0 0 1 3.712-18.602667 27.221333 27.221333 0 0 1 2.688-4.224z"
              p-id={2747}
            />
          </svg>
        </div>
        <div className="logo_container">
          <svg
            width="0"
            height="0"
            style={{
              position: "absolute",
              width: 0,
              height: 0,
              overflow: "hidden",
            }}
            aria-hidden="true"
          >
            <filter
              id="logo-white-to-dark-successpay"
              colorInterpolationFilters="sRGB"
            >
              <feColorMatrix
                type="matrix"
                values="1 0 -1.221 0 0.321
                        0 1 -1.221 0 0.321
                        0 0 -0.221 0 0.321
                        0 0 0 1 0"
              />
            </filter>
          </svg>
          <img
            src={process.env.PUBLIC_URL + "/head/head-new.png"}
            alt="gyo"
            className="gyo_logo"
            style={{ height: "40px" }}
          />
        </div>
        <div className="tw-w-1/3" />
      </div>
      {/* main */}
      <div className="success_box">
        <img
          alt="Order Successful"
          src={process.env.PUBLIC_URL + "/main/main1.avif"}
          className="success_box_img"
        />
        <div className="success_box_txt1">
          {t("success.box.thankYou")}
          <br />
          {t("success.box.difference")}
          <br />
          {t("success.box.confirm", {
            channels: t("success.box.channels", { email, phone }),
          })}
        </div>

        {/* Share Section */}
        <div className=" success_pay_share">
          {shareOptions.map((option) => (
            <button
              key={option.id}
              className="quick-share-modal__share-option"
              type="button"
              onClick={() => handleShareOptionClick(option)}
              aria-label={`Share via ${option.name}`}
            >
              <span
                className="quick-share-modal__share-icon"
                style={{ color: option.color }}
              >
                {option.icon}
              </span>
            </button>
          ))}
        </div>
        {progress > 0 && (
          <div className="quick-share-modal__progress-section quick-share-modal__progress-section-success">
            <div className="quick-share-modal__progress-header">
              <span>{t("success.share.progress")}</span>
              <span>{progress}%</span>
            </div>

            <div className="quick-share-modal__progress-bar">
              <div
                className="quick-share-modal__progress-fill"
                style={{ width: `${progress}%` }}
              ></div>
            </div>

            <p className="quick-share-modal__share-count">
              {t("success.share.sharedCount", { count: shareCount })}
            </p>
            {!msgHidden && returnMsg && (
              <p className="quick-share-modal__return-msg">{returnMsg}</p>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default PaySuccess;
